module.exports = __webpack_public_path__ + "static/media/iconProfessorF.b65aee80.svg";